import '@mui/lab';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import './assets/styles/theme/colors.sass';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    orange: true;
    blue: true;
    transparent: true;
  }
}

const orange = '#FF9F2F';
const red = '#FC5808';
const blue = '#022168';
const darkBlue = '#011b56';
const lightBlue = '#E4EAF6';
const lightGrayBlue = ' #D7DDE9';
const colorLightGray = '#C4C4C4';
const colorGray = '#949494';
const colorWhiteBlue = '#F6F8FB';
const colorDark = '#191919';
const white = '#FFFFFF';
export const theme = createTheme({
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'orange' },
          style: {
            textTransform: 'none',
            backgroundColor: `${orange}`,
            color: `${white}`,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '20px',
            height: '44px',
            borderRadius: '8px',
            transition: '0.5s all easy-in-out',
            zIndex: 2,
            '&:hover': {
              backgroundColor: `${red}`,
              color: `${white}`,
            },
          },
        },
        {
          props: { variant: 'blue' },
          style: {
            textTransform: 'none',
            backgroundColor: `${blue}`,
            color: `${white}`,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '20px',
            height: '44px',
            borderRadius: '8px',
            zIndex: 3,
            transition: '0.5s all ease-in-out',
            '&:hover': {
              backgroundColor: `${darkBlue}`,
            },
            '&:active': {
              backgroundColor: `${orange}`,
            },
          },
        },
        {
          props: { variant: 'transparent' },
          style: {
            textTransform: 'none',
            backgroundColor: `transparent`,
            color: `#191919`,
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            height: '44px',
            borderRadius: '8px',
            zIndex: 3,
            border: '1px solid #D7DDE9',
            transition: '0.5s all ease-in-out',
          },
        },
      ],
    },
  },
});
